// Customers index
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state: {
    items: [],
    count: '',
    entity: {},
    customer: {},
  },
  actions,
  mutations,
  getters,
};
